"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OtherCardChange = exports.OTHER_CARD_BLOCK_LIMIT = exports.NO_CARD_PREVIEWS = exports.CardPreviewsContext = void 0;
exports.otherCardChangeOf = otherCardChangeOf;
var _react = _interopRequireWildcard(require("react"));
var _CardLiveChange = require("./CardLiveChange");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var NO_CARD_PREVIEWS = exports.NO_CARD_PREVIEWS = {
  previewOf: function previewOf() {
    return null;
  },
  signedInAuthorName: null
};
var OTHER_CARD_BLOCK_LIMIT = exports.OTHER_CARD_BLOCK_LIMIT = 1;
var CardPreviewsContext = exports.CardPreviewsContext = /*#__PURE__*/(0, _react.createContext)(NO_CARD_PREVIEWS);
var OtherCardChange = exports.OtherCardChange = function OtherCardChange(_ref) {
  var actionId = _ref.actionId;
  var _useContext = (0, _react.useContext)(CardPreviewsContext),
    previewOf = _useContext.previewOf,
    signedInAuthorName = _useContext.signedInAuthorName;
  var preview = previewOf(actionId);
  if (preview === null) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CardLiveChange.CardLiveChange, {
    preview: preview,
    signedInAuthorName: signedInAuthorName,
    blockLimit: OTHER_CARD_BLOCK_LIMIT,
    applied: false,
    "data-sentry-element": "CardLiveChange",
    "data-sentry-component": "OtherCardChange",
    "data-sentry-source-file": "CardPreviewsContext.tsx"
  });
};
function otherCardChangeOf(cardPreviews, actionId) {
  return cardPreviews.previewOf(actionId) === null ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(OtherCardChange, {
    actionId: actionId,
    "data-sentry-element": "OtherCardChange",
    "data-sentry-component": "otherCardChangeOf",
    "data-sentry-source-file": "CardPreviewsContext.tsx"
  });
}